import { marked } from "marked";
import DOMPurify from "dompurify";

/**
 * Convertit la reponse Markdown de l'assistant en HTML sur.
 *
 * Le projet affiche les messages via dangerouslySetInnerHTML : sans
 * assainissement, on injecterait dans le DOM du HTML produit par un modele de
 * langage, potentiellement influence par le contenu des PDF indexes.
 */
marked.setOptions({ breaks: true, gfm: true });

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "del",
  "code",
  "pre",
  "blockquote",
  "ul",
  "ol",
  "li",
  "h3",
  "h4",
  "h5",
  "h6",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "a",
  "hr",
];

export const renderIaMarkdown = (text) => {
  if (!text) return "";

  const html = marked.parse(String(text));

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
    // Les liens produits par le modele s'ouvrent dans un nouvel onglet sans
    // donner acces a window.opener.
    ADD_ATTR: ["target"],
  });
};

export default renderIaMarkdown;
